// extracted by mini-css-extract-plugin
export default {"userCol":"Logs_userCol__PcfPL","colLabel":"Logs_colLabel__bKwnS"};